var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSpeechUnderstanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.91 235.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}.cls-2{fill:none;stroke:#00a99d;stroke-linecap:round;stroke-miterlimit:10;stroke-width:7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "understanding_words",
    "data-name": "understanding words"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.81,34.9c0-.25-.05-.5-.09-.75a38.35,38.35,0,0,0-7.6-18.76,39.37,39.37,0,0,0-9.26-8.77,38.84,38.84,0,0,0-60.3,28.1,37.51,37.51,0,0,0-.22,4.12c0,1.1,0,2.19.14,3.26a38.81,38.81,0,0,0,36.94,35.53c.58,0,1.16,0,1.75,0s1.16,0,1.74,0a38.82,38.82,0,0,0,37-35.53c.08-1.07.13-2.16.13-3.26C150,37.51,149.94,36.2,149.81,34.9ZM119.46,68.29c-8.42,0-15.25-4.63-15.25-10.33a7.59,7.59,0,0,1,1.41-4.34c2.42-3.54,7.72-6,13.84-6a20.85,20.85,0,0,1,8.2,1.61c4.25,1.83,7.07,5,7.07,8.72C134.73,63.66,127.89,68.29,119.46,68.29ZM150.69,10.7c-.3-.44-.61-.86-.93-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,39.24a38.83,38.83,0,0,0-58.76-29.07c-.53.31-1,.64-1.54,1a39.17,39.17,0,0,0-11.05,11.33,38.56,38.56,0,0,0-5.81,16.19h0c0,.26-.05.51-.08.76-.13,1.3-.2,2.61-.2,3.94,0,1.1.05,2.18.14,3.25a38.77,38.77,0,0,0,36.95,35.53c.58,0,1.16,0,1.74,0s1.17,0,1.75,0a38.83,38.83,0,0,0,36.94-35.54c.09-1.07.14-2.15.14-3.25A37.69,37.69,0,0,0,373.59,39.24ZM326.73,72.68c-8.39,0-15.19-4.61-15.19-10.28,0-3.63,2.78-6.83,7-8.66a20.76,20.76,0,0,1,8.19-1.62c6.12,0,11.4,2.45,13.8,6a7.59,7.59,0,0,1,1.39,4.3C341.92,68.07,335.12,72.68,326.73,72.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,81.87,68.41,124.33,61,140.39l-1.6,3.48L47.11,170.6l2.41-16.52-8.84,19.2-5.32,11.57-.34.73-1.84,4L28,200.81l-7.32,15.91A10.84,10.84,0,0,1,6.35,222l-.07,0A10.84,10.84,0,0,1,1,207.66l.53-1.16,13.83-30.05.73-1.57.79-1.71h0l4.38-9.52,8.51-18.47h0l9.51-20.69.67-1.45,2.74-5.94.44-1,3.37-7.31,5.93-12.9,1.46-3.16,2.77-6,.52-1.14a10.21,10.21,0,0,1,.77-1.38,10.42,10.42,0,0,1,3-3h0a6.15,6.15,0,0,1,5.82-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.87,94.65l-11.06,24-7.39,16.06-.25.55-8.64,18.77v0l-8.84,19.2-5.32,11.57-.34.73-1.84,4L28,200.81l-7.32,15.91A10.84,10.84,0,0,1,6.35,222l-.07,0A10.84,10.84,0,0,1,1,207.66l.53-1.16,13.83-30.05.73-1.57.79-1.71h0l4.38-9.52,8.51-18.47h0l9.51-20.69.67-1.45,2.74-5.94.44-1,3.37-7.31,5.93-12.9,1.46-3.16,2.77-6,.52-1.14a10.21,10.21,0,0,1,.77-1.38,10.42,10.42,0,0,1,3-3h0a10.81,10.81,0,0,1,10.6-.91l.08,0A10.84,10.84,0,0,1,76.87,94.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,96l-5.76,39.49v0l-4.67,32h0l-7.41,50.79a6.17,6.17,0,0,1-7,5.21L47.1,213.24a6.17,6.17,0,0,1-5.2-7l4.94-33.88.26-1.76v0l2.41-16.52v0l4.28-29.35v0l1.41-9.64v0l2.14-14.72L59.74,84a6,6,0,0,1,1.15-2.78h0a6.14,6.14,0,0,1,5.81-2.43L88,81.87l49,7.15.36,0a5.87,5.87,0,0,1,1.91.62A6.18,6.18,0,0,1,142.5,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.8,233.13a10.7,10.7,0,0,1-5.79,2.51l-1.44.16a10.83,10.83,0,0,1-11.93-9.53l-6.57-58.74h0l-7.37-65.93a10.84,10.84,0,0,1,9.54-11.93l1.44-.16a5.49,5.49,0,0,1,.7,0,10.55,10.55,0,0,1,2.82.24A10.82,10.82,0,0,1,147.61,99l5.22,46.7.17,1.47,1,8.84,3.2,28.57,4.37,39.1A10.81,10.81,0,0,1,157.8,233.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.8,233.13a10.82,10.82,0,0,1-11.23-9.58l-4-35.43-1.45-13-4.42-39.61v0l-4.1-36.65a10.83,10.83,0,0,1,3.74-9.43c.18-.16.36-.29.55-.43l.36,0a5.87,5.87,0,0,1,1.91.62A10.82,10.82,0,0,1,147.61,99l5.22,46.7.17,1.47,1,8.84,3.2,28.57,4.37,39.1A10.81,10.81,0,0,1,157.8,233.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.52,100.41c0,.49,0,1-.07,1.44a17,17,0,0,1-8.24,13.23,16.82,16.82,0,0,1-4.92,2,17.41,17.41,0,0,1-3.1.43c-.25,0-.51,0-.76,0s-.52,0-.77,0a17.11,17.11,0,0,1-3-.41h0l.45-1,3.37-7.31,5.93-12.9,1.46-3.16,2.77-6,.21.16a15.64,15.64,0,0,1,2.16,2,17,17,0,0,1,4.4,9.73A15.44,15.44,0,0,1,63.52,100.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.73,175.82a6.6,6.6,0,0,1-2.79.61,6.73,6.73,0,0,1-6.12-3.89L61,140.39l-2.6-5.65-.49-1.07-4.12-9v0l-3.52-7.63-3.77-8.17,0-.08,5.93-12.9,1.46-3.16L54,93l3.38,7.32,3.94,8.54,4.51,9.83,2.6,5.65L88,166.92A6.72,6.72,0,0,1,84.73,175.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.73,134.9a13.46,13.46,0,0,1-11.37,13.69l-.6.09-.6,0a13.51,13.51,0,0,1-5.86-.91l-2.65-23.69a13.49,13.49,0,0,1,20.73,8c0,.1,0,.18.06.26a12,12,0,0,1,.22,1.36C183.7,134.16,183.72,134.53,183.73,134.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.73,134.9a13.46,13.46,0,0,1-11.37,13.69l-.6.09-.6,0a13.51,13.51,0,0,1-5.86-.91l-2.65-23.69a13.49,13.49,0,0,1,20.73,8c0,.1,0,.18.06.26a12,12,0,0,1,.22,1.36C183.7,134.16,183.72,134.53,183.73,134.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.18,160.08l-.84,25.14-.24,7.05a7.5,7.5,0,0,1-7.74,7.23l-2.29-.07L165.78,152l9.16.3a7.78,7.78,0,0,1,2.7.61A7.53,7.53,0,0,1,182.18,160.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.21,
    y: 173.74,
    width: 51.06,
    height: 8,
    rx: 2.71,
    transform: "matrix(0.22, 0.98, -0.98, 0.22, 316.53, -40.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.25,107.93c.06.54.09,1.08.11,1.61a19.26,19.26,0,0,1-16.27,19.57l-.86.11-.86.08a19.26,19.26,0,0,1-20.18-15.49c-.11-.53-.19-1.06-.25-1.6a17.74,17.74,0,0,1-.12-2,19.27,19.27,0,0,1,38-4.53c0,.12.05.24.08.37C249.07,106.63,249.17,107.27,249.25,107.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.25,107.93c.06.54.09,1.08.11,1.61a19.26,19.26,0,0,1-16.27,19.57l-.86.11-.86.08a19.26,19.26,0,0,1-20.18-15.49c-.11-.53-.19-1.06-.25-1.6a17.74,17.74,0,0,1-.12-2,19.27,19.27,0,0,1,38-4.53c0,.12.05.24.08.37C249.07,106.63,249.17,107.27,249.25,107.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 204.86,
    y: 134.12,
    width: 41.51,
    height: 67.44,
    rx: 6.25,
    transform: "translate(5.74 -7.46) rotate(1.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 214.87,
    y: 164.98,
    width: 72.99,
    height: 11.44,
    rx: 3.87,
    transform: "translate(362.35 -112.15) rotate(77.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 160.78,
    y: 165.42,
    width: 77.11,
    height: 10.72,
    rx: 3.63,
    transform: "translate(-25.48 306.26) rotate(-71.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.93,106c.14.63.24,1.27.32,1.93s.09,1.08.11,1.61a19.27,19.27,0,0,1-1.71,8.49l-4-3.18a5.36,5.36,0,0,1,5.18-9.22C248.88,105.75,248.9,105.87,248.93,106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.34,124.61a11.44,11.44,0,0,1-.09,1.43,10.41,10.41,0,0,1-.16,1.12A13.49,13.49,0,0,1,279,138l-.61-.06-.6-.09a13.49,13.49,0,0,1-11.38-13.68c0-.38,0-.75.09-1.14s.12-.89.21-1.34c0-.09,0-.18.06-.26a13.47,13.47,0,0,1,21.73-7.27,12.55,12.55,0,0,1,1.68,1.66A13.48,13.48,0,0,1,293.34,124.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.34,124.61a11.44,11.44,0,0,1-.09,1.43,10.41,10.41,0,0,1-.16,1.12A13.49,13.49,0,0,1,279,138l-.61-.06-.6-.09a13.49,13.49,0,0,1-11.38-13.68c0-.38,0-.75.09-1.14s.12-.89.21-1.34c0-.09,0-.18.06-.26a13.47,13.47,0,0,1,21.73-7.27,12.55,12.55,0,0,1,1.68,1.66A13.48,13.48,0,0,1,293.34,124.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.37,141.31l-10.63,46.93a7.51,7.51,0,0,1-4.72-6.69l-.42-12.48-.66-19.71a7.48,7.48,0,0,1,4.06-6.9,7.36,7.36,0,0,1,3.18-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.05,180.57a7.51,7.51,0,0,1-7.24,7.73l-7.52.25,8.64-38.12h0l1.78-7.93a7.49,7.49,0,0,1,3.26,5.9l.64,19.18h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 239.44,
    y: 162.97,
    width: 51.06,
    height: 8,
    rx: 2.71,
    transform: "translate(486.32 -54.6) rotate(102.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.68,121.7a11.87,11.87,0,0,0-.22,1.35,10.73,10.73,0,0,0-.08,1.13,13.5,13.5,0,0,0,1.19,5.94l2.79-2.23a3.75,3.75,0,0,0-3.63-6.45C266.71,121.53,266.7,121.61,266.68,121.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.38,147.46c0,.34,0,.67-.05,1a11.81,11.81,0,0,1-.74,3.26,12,12,0,0,1-9.42,7.56l1.58-14.12h0l0-.45,3.32-7.13.09.06a11.85,11.85,0,0,1,2.69,2.55h0a11.89,11.89,0,0,1,2.39,6A10.69,10.69,0,0,1,38.38,147.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.38,147.46c0,.34,0,.67-.05,1a11.81,11.81,0,0,1-.74,3.26,12,12,0,0,1-9.42,7.56l1.58-14.12h0l0-.45,3.32-7.13.09.06a11.85,11.85,0,0,1,2.69,2.55h0a11.89,11.89,0,0,1,2.39,6A10.69,10.69,0,0,1,38.38,147.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.33 191.68 53.66 199.64 46.3 183.65 46.29 183.64 45.8 182.56 45.21 181.28 45.78 180.07 45.78 180.06 48.88 173.33 52.69 181.6 57.33 191.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75,128.83a5.4,5.4,0,0,1,0,.56l-3.21,28.7-.31,2.81L38,162.52l-.26,2.41h0l-2.1,18.7a5.48,5.48,0,0,1-.29,1.21l-.34.73a5.07,5.07,0,0,1-9.48-2.5,5.78,5.78,0,0,1,0-.58l2.25-20.09.35-3.12,1.58-14.12h0l0-.45,3.32-7.13,6.12-13.12s0,0,0,0A5.1,5.1,0,0,1,41.75,128.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.06,
    y: 90.1,
    width: 83.63,
    height: 135.88,
    rx: 6.25,
    transform: "translate(732.82 262.94) rotate(171.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.06,108.57l-10.13,44.75v0L309,175.17l-.85,3.71-7.62,33.7a10.84,10.84,0,0,1-12.91,8.15l-1.34-.3a11,11,0,0,1-2.63-1h0a10.86,10.86,0,0,1-5.5-12L285.26,176l7.1-31.32h0l1.47-6.52.26-1.16,7.57-33.44A10.86,10.86,0,0,1,311,95.16h0a10.66,10.66,0,0,1,3.59.2l.51.11.82.19A10.83,10.83,0,0,1,324.06,108.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.47,
    y: 145.33,
    width: 155.37,
    height: 21.6,
    rx: 10.8,
    transform: "translate(439.81 593.99) rotate(-114.72)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "soundwave3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291,62.27s-27.78-13.44-7.68-33.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.3,72.24S242.06,52.77,271.18,23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257,13.68C249.26,21.6,244.8,29,242.73,35.86c-4.43,14.62,1.92,26.65,10,35.36a78.94,78.94,0,0,0,20.86,15.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "soundwave4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.21,65.08s30.14-16.49,6.64-38.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.48,75.68s43.65-23.89,9.62-55.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.32,9.17c9.07,8.36,14.43,16.36,17.12,23.86,5.74,16-.64,29.73-9.13,39.86A87.9,87.9,0,0,1,178,91.42"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeechUnderstanding);
export default __webpack_public_path__ + "static/media/ic_speechUnderstanding.fb407c8dbdacc415ab39a6e5c944d0e6.svg";
export { ForwardRef as ReactComponent };